import type { TagProps } from '@zillow/constellation';
import { Accordion } from '@zillow/constellation';
import { Heading } from '@zillow/constellation-10';

import { StyledAccordionItem } from './StyledComponents';

type AccordionContentContainerProps = {
  content: React.ReactNode;
  header?: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  tag?: typeof TagProps | null | undefined;
  id?: string | null;
  eventId?: string;
  accordionIndex?: number;
};
/*
 * NOTE: This component is to be used with `Accordion` from the `@zillow/constellation`
 */
const AccordionContentContainer = ({
  content,
  header = '',
  headingLevel = 5,
  tag = null,
  id = null,
  eventId,
  accordionIndex,
}: AccordionContentContainerProps) => {
  return (
    <StyledAccordionItem id={id} data-eventid={eventId} data-accordion-index={accordionIndex}>
      <Accordion.Header>
        <Heading level={headingLevel}>{header}</Heading>
        {tag}
      </Accordion.Header>
      <Accordion.Panel>{content}</Accordion.Panel>
    </StyledAccordionItem>
  );
};

export default AccordionContentContainer;
